// @mui
import { alpha, styled } from '@mui/material/styles';
import { ListItemText, ListItemButton, ListItemIcon } from '@mui/material';
// config
import { ICON, NAVBAR } from '../../../config';

// ----------------------------------------------------------------------

export const ListItemStyle = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'activeRoot' && prop !== 'activeSub' && prop !== 'subItem',
})(({ activeRoot, activeSub, subItem, theme }) => ({
  ...theme.typography.body2,
  position: 'relative',
  height: NAVBAR.DASHBOARD_ITEM_ROOT_HEIGHT,
  textTransform: 'capitalize',
  paddingLeft: theme.spacing(2.5),
  paddingRight: theme.spacing(2),
  marginBottom: theme.spacing(0.5),
  marginLeft: theme.spacing(1.5),
  marginRight: theme.spacing(1.5),
  color: '#475569', // Slate 600
  borderRadius: 12,
  // activeRoot
  ...(activeRoot && {
    fontWeight: 700,
    color: '#00B37A',
    backgroundColor: '#F4FBF7',
    '& .MuiListItemIcon-root': {
      color: '#00B37A',
    },
    '&:hover': {
      backgroundColor: '#E8F5E9',
    },
  }),
  // activeSub
  ...(activeSub && {
    fontWeight: 700,
    color: '#00B37A',
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: '#F4FBF7',
    },
  }),
  // subItem
  ...(subItem && {
    height: NAVBAR.DASHBOARD_ITEM_SUB_HEIGHT,
  }),
  '&:hover': {
    backgroundColor: '#F1F5F9',
  },
}));

export const ListItemTextStyle = styled(ListItemText, {
  shouldForwardProp: (prop) => prop !== 'isCollapse',
})(({ isCollapse, theme }) => ({
  whiteSpace: 'nowrap',
  transition: theme.transitions.create(['width', 'opacity'], {
    duration: theme.transitions.duration.shorter,
  }),
  ...(isCollapse && {
    width: 0,
    opacity: 0,
  }),
}));

export const ListItemIconStyle = styled(ListItemIcon)({
  width: ICON.NAVBAR_ITEM,
  height: ICON.NAVBAR_ITEM,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& svg': { width: '100%', height: '100%' },
});
